import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	forwardRef,
	HostBinding,
	inject,
	Input,
} from "@angular/core";
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from "@angular/forms";

import { COLORS } from "./colors";

const INPUT_CONTROL_ACCESSOR = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => ColorInputComponent),
	multi: true,
};

@Component({
	selector: "ic-color-input",
	styleUrls: ["input.component.scss"],
	providers: [INPUT_CONTROL_ACCESSOR],
	templateUrl: "./input.component.html",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ColorInputComponent implements ControlValueAccessor {
	private cdRef = inject(ChangeDetectorRef);

	@Input() label: string;
	@Input() required = true;
	@Input() help: string;

	colors = COLORS;
	value: any = "";

	private onTouch = () => {}; // eslint-disable-line @typescript-eslint/no-empty-function
	private onModelChange = (_: unknown) => {};

	writeValue(value: string) {
		this.value = value;
		this.cdRef.markForCheck();
	}

	registerOnChange(fn: (v: unknown) => void) {
		this.onModelChange = fn;
	}

	registerOnTouched(fn: () => void) {
		this.onTouch = fn;
	}

	selectColor(color: string) {
		this.onChange(color);
	}

	onChange(value: string) {
		this.value = value;
		this.onModelChange(value);
	}

	onTouched() {
		this.onTouch();
	}
}

@Component({
	selector: "ic-color-option",
	template: "<mark></mark>",
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ColorOptionComponent {
	@HostBinding("style.background") backgroundColor: string;
	@Input()
	set color(value: string) {
		this.backgroundColor = value;
	}
}
